import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        // Legacy Export -------------------------------------
        async getLegacyExportView() {
            var meta = {
                clientApiMethod: 'getExportView',
                input: {},
            }
            var response = await client().get(store.state.apiRouteRoot + "LegacyExport/", { meta: meta });
            return response.data;
        },

        async getLegacyExportFile(fileReuqestParams) {
            var meta = {
                clientApiMethod: 'getExportFile',
                input: { fileReuqestParams: fileReuqestParams },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "LegacyExport/File", { params: fileReuqestParams, meta: meta, responseType: 'arraybuffer' });
            return response;
        },

        async deleteLegacyExportFiles(date) {
            var meta = {
                clientApiMethod: 'deleteExportFiles',
                input: { date: date },
            }
            var response = await client().delete(store.state.apiRouteRoot + "LegacyExport/?displayedExportDate=" + date, { meta: meta });
            return response.data;
        },
        //---------------------------------------------------


        // Modern Export ------------------------------------
        async getExportModern() {
            var meta = {
                clientApiMethod: 'getExportModern',
                input: {},
            }
            var response = await client().get(store.state.apiRouteRoot + "Export", { meta: meta });
            return response.data;
        },

        async clearTransaction(exportDate, fileName) {
            var meta = {
                clientApiMethod: 'clearTransaction',
                input: { fileName: fileName },
                successText: i18n.t("servicesystem.responses.cleared_object"),
                noClutter: true,
                icon: "mdi-information-outline",
                color: "warning",
                onErrorMessage: (event) => event.response.data.Message
            }
            var response = await client()
                .delete(store.state.apiRouteRoot + "Export/File", { params: { exportDate: exportDate, fileName: fileName }, meta: meta });
            return response.data;
        },

        async restoreTransaction(fileName) {
            var meta = {
                clientApiMethod: 'restoreTransaction',
                input: { fileName: fileName },
                successText: i18n.t("servicesystem.responses.restored_object"),
                noClutter: true,
                icon: "mdi-information-outline",
                color: "warning",
                onErrorMessage: (event) => event.response.data.Message
            }
            var response = await client()
                .patch(store.state.apiRouteRoot + "Export/Restore", null, { params: { fileName: fileName }, meta: meta });
            return response.data;
        },
        //---------------------------------------------------
    }
}